import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import GroupedSelect from './GroupedSelect';
import ClientProvider from './client';
export default createDemo(import.meta.url, GroupedSelect, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/selects/demos/grouped/GroupedSelect.tsx",
    "fileName": "GroupedSelect.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport InputLabel from '@mui/material/InputLabel';\nimport MenuItem from '@mui/material/MenuItem';\nimport ListSubheader from '@mui/material/ListSubheader';\nimport FormControl from '@mui/material/FormControl';\nimport Select from '@mui/material/Select';\n\nexport default function GroupedSelect() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 1,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const nativeId = React.useId();\n  const id = React.useId();\n  return (\n    <div>\n      <FormControl sx={{ m: 1, minWidth: 120 }}>\n        <InputLabel htmlFor={`${nativeId}-select`}>Grouping</InputLabel>\n        <Select native defaultValue=\"\" id={`${nativeId}-select`} label=\"Grouping\">\n          <option aria-label=\"None\" value=\"\" />\n          <optgroup label=\"Category 1\">\n            <option value={1}>Option 1</option>\n            <option value={2}>Option 2</option>\n          </optgroup>\n          <optgroup label=\"Category 2\">\n            <option value={3}>Option 3</option>\n            <option value={4}>Option 4</option>\n          </optgroup>\n        </Select>\n      </FormControl>\n      <FormControl sx={{ m: 1, minWidth: 120 }}>\n        <InputLabel id={`${id}-label`}>Grouping</InputLabel>\n        <Select\n          defaultValue=\"\"\n          id={`${id}-select`}\n          label=\"Grouping\"\n          SelectDisplayProps={{\n            'aria-labelledby': `${id}-label`,\n          }}\n        >\n          <MenuItem value=\"\">\n            <em>None</em>\n          </MenuItem>\n          <ListSubheader>Category 1</ListSubheader>\n          <MenuItem value={1}>Option 1</MenuItem>\n          <MenuItem value={2}>Option 2</MenuItem>\n          <ListSubheader>Category 2</ListSubheader>\n          <MenuItem value={3}>Option 3</MenuItem>\n          <MenuItem value={4}>Option 4</MenuItem>\n        </Select>\n      </FormControl>\n    </div>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 50,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport InputLabel from '@mui/material/InputLabel';\nimport MenuItem from '@mui/material/MenuItem';\nimport ListSubheader from '@mui/material/ListSubheader';\nimport FormControl from '@mui/material/FormControl';\nimport Select from '@mui/material/Select';\n\nexport default function GroupedSelect() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 1
        },
        "  const nativeId = React.useId();\n  const id = React.useId();\n  return (\n    <div>\n      <FormControl sx={{ m: 1, minWidth: 120 }}>\n        <InputLabel htmlFor={`${nativeId}-select`}>Grouping</InputLabel>\n        <Select native defaultValue=\"\" id={`${nativeId}-select`} label=\"Grouping\">\n          <option aria-label=\"None\" value=\"\" />\n          <optgroup label=\"Category 1\">\n            <option value={1}>Option 1</option>\n            <option value={2}>Option 2</option>\n          </optgroup>\n          <optgroup label=\"Category 2\">\n            <option value={3}>Option 3</option>\n            <option value={4}>Option 4</option>\n          </optgroup>\n        </Select>\n      </FormControl>\n      <FormControl sx={{ m: 1, minWidth: 120 }}>\n        <InputLabel id={`${id}-label`}>Grouping</InputLabel>\n        <Select\n          defaultValue=\"\"\n          id={`${id}-select`}\n          label=\"Grouping\"\n          SelectDisplayProps={{\n            'aria-labelledby': `${id}-label`,\n          }}\n        >\n          <MenuItem value=\"\">\n            <em>None</em>\n          </MenuItem>\n          <ListSubheader>Category 1</ListSubheader>\n          <MenuItem value={1}>Option 1</MenuItem>\n          <MenuItem value={2}>Option 2</MenuItem>\n          <ListSubheader>Category 2</ListSubheader>\n          <MenuItem value={3}>Option 3</MenuItem>\n          <MenuItem value={4}>Option 4</MenuItem>\n        </Select>\n      </FormControl>\n    </div>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 50,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/InputLabel",
      "@mui/material/MenuItem",
      "@mui/material/ListSubheader",
      "@mui/material/FormControl",
      "@mui/material/Select"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
